const MarketTradeInfo = () => {
  return (
    <div className="w-full flex flex-col items-start gap-y-[5px] mb-[35px]">
      <p className="text-[13px] font-normal text-[#4a4a4a] w-full flex items-center">
        Available: <span className="ml-auto">0 BTC = 0 USD</span>
      </p>

      <p className="text-[13px] font-normal text-[#4a4a4a] w-full flex items-center">
        Volume: <span className="ml-auto">0 BTC = 0 USD</span>
      </p>

      <p className="text-[13px] font-normal text-[#4a4a4a] w-full flex items-center">
        Margin: <span className="ml-auto">0 BTC = 0 USD</span>
      </p>

      <p className="text-[13px] font-normal text-[#4a4a4a] w-full flex items-center">
        Fee: <span className="ml-auto">0 BTC = 0 USD</span>
      </p>
    </div>
  )
}

export default MarketTradeInfo
